import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';

import { Button } from './styles';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '2px',
    padding: 30,
    width: 360,
  },
  overlay: {
    backgroundColor: 'rgba(51, 51, 51, 0.5)',
    zIndex: 20,
  },
};

ReactModal.setAppElement('#root');

function Modal(props: any) {
  const [modalIsOpen, setIsOpen] = React.useState(props.isOpen);

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  function afterOpenModal() {}

  function closeModal() {
    if (props.className == 'hello showCross') {
      return;
    } else if (props.className == 'hello ') {
      return;
    } else if (props.className == 'damagePreventionModal') {
      return;
    } else if (props.className == 'feedback') {
      return;
    } else {
      setIsOpen(false);
      props.onClose();
    }
  }

  return (
    <div>
      <ReactModal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className={props.className ? props.className : ''}
      >
        <Button className={`close-btn ${props.type === 'pod-multiple' ? 'close-button-pod' : ''}`} onClick={closeModal}>
          &times;
        </Button>

        {props.children}
      </ReactModal>
    </div>
  );
}

ReactDOM.render(<Modal />, document.getElementById('root'));

export default Modal;
